// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetLatest (params?: {}): Promise<implicitReturnType>;
    privatePostOrders (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersHistory (params?: {}): Promise<implicitReturnType>;
    privatePostMyCoinDeposit (params?: {}): Promise<implicitReturnType>;
    privatePostMyCoinSend (params?: {}): Promise<implicitReturnType>;
    privatePostQuoteBuy (params?: {}): Promise<implicitReturnType>;
    privatePostQuoteSell (params?: {}): Promise<implicitReturnType>;
    privatePostMyBalances (params?: {}): Promise<implicitReturnType>;
    privatePostMyOrders (params?: {}): Promise<implicitReturnType>;
    privatePostMyBuy (params?: {}): Promise<implicitReturnType>;
    privatePostMySell (params?: {}): Promise<implicitReturnType>;
    privatePostMyBuyCancel (params?: {}): Promise<implicitReturnType>;
    privatePostMySellCancel (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyBalances (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyBalancesCointype (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyDeposits (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyWithdrawals (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyTransactions (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyTransactionsCointype (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyTransactionsOpen (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyTransactionsCointypeOpen (params?: {}): Promise<implicitReturnType>;
    privatePostRoMySendreceive (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyAffiliatepayments (params?: {}): Promise<implicitReturnType>;
    privatePostRoMyReferralpayments (params?: {}): Promise<implicitReturnType>;
    v2PublicGetLatest (params?: {}): Promise<implicitReturnType>;
    v2PublicGetLatestCointype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetLatestCointypeMarkettype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetBuypriceCointype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetBuypriceCointypeMarkettype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetSellpriceCointype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetSellpriceCointypeMarkettype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetOrdersOpenCointype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetOrdersOpenCointypeMarkettype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetOrdersCompletedCointype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetOrdersCompletedCointypeMarkettype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetOrdersSummaryCompletedCointype (params?: {}): Promise<implicitReturnType>;
    v2PublicGetOrdersSummaryCompletedCointypeMarkettype (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostStatus (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMyCoinDeposit (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostQuoteBuyNow (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostQuoteSellNow (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostQuoteSwapNow (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMyBuy (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMyBuyEdit (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMySell (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMySellEdit (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMyBuyNow (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMySellNow (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMySwapNow (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMyBuyCancel (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMyBuyCancelAll (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMySellCancel (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMySellCancelAll (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMyCoinWithdrawSenddetails (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostMyCoinWithdrawSend (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoStatus (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoOrdersMarketOpen (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoOrdersMarketCompleted (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyBalances (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyBalanceCointype (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyOrdersMarketOpen (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyOrdersLimitOpen (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyOrdersCompleted (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyOrdersMarketCompleted (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMySendreceive (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyDeposits (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyWithdrawals (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyAffiliatepayments (params?: {}): Promise<implicitReturnType>;
    v2PrivatePostRoMyReferralpayments (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
